export const addSpanAtPos = (items, pos) => {
  return (
    <>
      {items.map((v, i) => {
        if (i === pos) return <span> {v} </span>;
        return v;
      })}
    </>
  );
};

export const addBreakLine = (items) => {
  return items.map((v, i) => {
    if (i === items.length - 1) return v;
    return (
      <>
        {v} <br />
      </>
    );
  });
};
